import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../../utils/withRouter';
import memoizeOne from 'memoize-one';
import { FormattedMessage, injectIntl } from 'react-intl';
import { bindActionCreators, Dispatch } from 'redux';
import { RootState } from '../../../reducers';
import * as _actionsJourney from '../../../actions/journey1';
import { Button, EButtonType, Input } from '@repo/apg-ui';
import './Step3.scss';
import * as actions from '../../../actions/index';
import { defined } from '../../../utils/variableEvaluation';
import { useNavigate } from 'react-router';
import { PartiallyIntegratedUserDataEC } from '../../../reducers/app';

interface Props {
  locales: any;
  intl: any;
  userDataEC: PartiallyIntegratedUserDataEC;
  actionsJourney: typeof _actionsJourney;
  history: any;
  validationMessageConfig: any;
  possibleBookingDates: any;
}

const Step3 = (props: Props) => {
  const [budget, setBudget] = React.useState(props.userDataEC.budget || '');
  const navigate = useNavigate();

  useEffect(() => {
    let payload = {};
    payload['coordinates'] = Object.keys(props.userDataEC.locations).map((locationKey) => {
      const location = props.userDataEC.locations[locationKey];
      return {
        name: location.address,
        longitude: location.lngLtd.lng,
        latitude: location.lngLtd.lat,
        radius: location.circle.radius,
        mode: location.types.includes('locality') ? 0 : 1,
      };
    });

    if (Object.keys(props.userDataEC.locations).length === 0) {
      navigate({ pathname: '/journey1/2' });
    }
  }, []);

  // componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
  //     if (prevState.budget !== this.state.budget) {
  //         this.props.actionsJourney.updateBudget(this.state.budget);
  //     }
  // }

  const isDisableButton = (budget: string) => !(defined(budget) && parseInt(budget) > 0);

  const memoizedIsDisableButton = memoizeOne(isDisableButton);

  const handleNext = () => {
    const { actionsJourney } = props;

    if (!memoizedIsDisableButton(budget)) {
      actionsJourney.updateBudget(budget);
      navigate({ pathname: '/journey1/4' });
    }
  };

  return (
    <div className='step3'>
      <div>
        <div className='header'>
          <h4 className='title-journey'>
            <FormattedMessage
              id='ec.journey01.step03.header'
              defaultMessage='Wie hoch soll das Budget für Ihre Werbekampagne sein?'
            />
          </h4>
        </div>
        <div className='d-flex flex-wrap'>
          <p className='text-left align-self-center me-48 fw-bold w-100 font-16'>
            <FormattedMessage
              id='ec.journey01.step03.withoutProductionCosts'
              defaultMessage='Bitte Werbebudget ohne Produktionskosten angeben.'
            />
          </p>

          <div className={'budgetInput col-6 px-0'}>
            <Input
              value={budget}
              min={props.userDataEC.minBudget}
              name={'address'}
              onChange={(name, value) => setBudget(value)}
              type='number'
              placeholder={props.intl.formatMessage({
                id: 'ec.journey01.step03.yourBudget',
                defaultMessage: 'Ihr Budget',
              })}
              inputWrapperClass='high col-12 px-0'
            >
              {props.intl.formatMessage({
                id: 'ec.journey01.step03.yourBudget',
                defaultMessage: 'Ihr Budget',
              })}
            </Input>
          </div>
        </div>

        <div className='d-flex twoButtons mt-5'>
          <Button onClick={() => navigate({ pathname: '/journey1/2' })} buttonType={EButtonType.InvertedPillMedium}>
            <FormattedMessage id='ec.components.buttons.back' defaultMessage='Zurück' />
          </Button>

          <Button
            isDisabled={memoizedIsDisableButton(budget)}
            onClick={handleNext}
            buttonType={EButtonType.PillMedium}
            className='ms-4'
          >
            <FormattedMessage id='ec.components.buttons.next' defaultMessage='Weiter' />
          </Button>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state: RootState, ownProps: any) {
  return {
    ...ownProps,
    ...state.app,
    ...state.router,
    locales: state.locales,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
  return {
    actionsJourney: bindActionCreators(_actionsJourney as any, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(Step3)));
